import { Component } from '@angular/core';

@Component({
    selector: 'app-footer-terms-of-use-popup',
    templateUrl: './footer-terms-of-use-popup.component.html',
    styleUrls: ['./footer-terms-of-use-popup.component.scss'],
    standalone: false
})
export class FooterTermsOfUsePopupComponent {

}
